import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentBrand: {},
  refreshBrandList: true,
  brandList: [],
};
const brandSlice = createSlice({
  name: "brands",
  initialState,
  reducers: {
    setSelectedBrand(state, action) {
      state.currentBrand = action?.payload;
    },
    setRefreshBrandList(state, action) {
      state.refreshBrandList = action?.payload;
    },
    setBrandList(state, action) {
      state.brandList = action?.payload;
      // if(state?.brandList?.length === 1)
      //   state.currentBrand = state.brandList[0];
    },
    clearBrand(state, action) {
      return initialState;
    },
  },
});

export const brandActions = brandSlice.actions;

export default brandSlice;
